export default function App() {
  return (
    <main
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Arial, sans-serif",
        background: "#f8f8f8",
        color: "#333",
        textAlign: "center",
        padding: "24px",
      }}
    >
      <div>
        <h1 style={{ fontSize: "32px", marginBottom: "12px" }}>
          MyLocalRIA is no longer active
        </h1>
        <p style={{ fontSize: "18px", maxWidth: "600px" }}>
          Thank you for visiting. This website has been taken offline.
        </p>
      </div>
    </main>
  );
}
